import Flag from '../ui-components/Flag'

const IntegrationHeader = ({ children, isInstalled, name, description }) => {
  return (
    <div>
      <div class='integrations-card__logo'>
        {children}
      </div>
      <div class='integrations-card__panel-heading-wrapper'>
        <h3 class='integrations-card__panel-heading'>{name}</h3>
        <p class='integrations-card__panel-subheading'>{description}</p>
      </div> {isInstalled ? <Flag text='Installed' success /> : null} </div>
  )
}
export default IntegrationHeader
